import classNames from "classnames";
import { EarlyWarning } from "@components/HourlyMain/Default";
import LayoutGrid from "@components/HomeMain/LayoutGrid";
import ChartData from "@components/HomeMain/ChartData";
import Sunrise from "@components/HomeMain/Sunrise";
import { useDispatch, useSelector } from "react-redux";
import { homeStateSelector, setHomeState } from "@/store/redux/modules/home";
import { appThemeStyle } from "@/config";
import { isTestLink, pxChangeVw } from "@/utils";
import { getWeekName } from "@/components/HomeMain/RecentWeather";
import useDayjs from "@/hooks/useDayjs";
import useDateFormat from "@/hooks/useDateFormat";
import lodash from "lodash";
import { useTranslation } from "react-i18next";
const { dayjs, userTimeZone } = useDayjs();
const countLines = (string: string | any[], wordCount = 21) => {
  if (!string) return 1;
  return Math.ceil(string.length / wordCount);
};
const DailyDetail: React.FC = () => {
  const homeState = useSelector(homeStateSelector);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dayItem, setDayItem] = useState<any>([]);
  const params: any = useParams();
  const { state } = useLocation();
  const deily_detail_ref = useRef<any>(null);
  const handleClick = (_date: any, index: number) => {
    return (_event: any) => {
      setDayItem(state.dayList[index]);
      setActiveIndex(index);
    };
  };
  const weatherStatus = homeState?.info?.weatherStatus || LocalStorage.getItem("info")?.weatherStatus;
  const tipsStyle = appThemeStyle?.[weatherStatus]?.tipsStyle ?? {};
  const dispatch = useDispatch();
  useEffect(() => {
    setActiveIndex(state.index);
    const scrollWidth = deily_detail_ref.current.scrollWidth;
    const length = state?.dayList?.length && (state.dayList.length > 0 ? state.dayList.length : 1);
    deily_detail_ref.current.scrollTo(state.index * (scrollWidth / length), 0);
    const dayItem = state.dayList[params.index];
    setDayItem(dayItem);
    if (homeState.info) {
      CookiesStorage.setItem("info", homeState.info);
    }
    dispatch(setHomeState({ info: CookiesStorage.getItem("info") }));
    LocalStorage.setItem("info", CookiesStorage.getItem("info"));
    return () => {
      CookiesStorage.removeItem("info");
    };
  }, []);
  const { shortDate } = useDateFormat();
  const { t: $t } = useTranslation();
  return (
    <>
      <div className="flex flex-col gap-y-10">
        <div className="p-0">
          <div
            ref={deily_detail_ref}
            className="overflow-x-auto overflow-y-hidden flex  gap-x-8 p-16 rounded-10 bg-[rgba(231,231,231,0.1)] backdrop-sepia-[blur(10px)] rounded-0 bg-[rgba(255,255,255,0.34)]"
          >
            {!!state?.dayList?.length &&
              state.dayList.map((item: any, index: number) => {
                const weekDayName = getWeekName(item.EpochDateTime);
                return (
                  <div
                    key={index}
                    className={classNames([
                      "text-12 rounded-8 p-8 items-center",
                      index === activeIndex ? "bg-[#ffb620]" : "bg-[rgba(142,138,138,0.25)]",
                    ])}
                    onClick={handleClick(item.date, index)}
                  >
                    <p>{weekDayName ?? item.Week}</p>
                    <p>
                      {item?.EpochDateTime &&
                        (userTimeZone
                          ? dayjs.unix(item.EpochDateTime).tz(userTimeZone).format(shortDate)
                          : item.DateShort)}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        {(isTestLink([...domainMap["wi"], ...domainMap["wg"]]) ||
          [...domainMap["wi"], ...domainMap["wg"]].includes(window.location.hostname)) && (
          <GoogleAd {...useGoogleAd("320x100", 4)} />
        )}
        {(isTestLink(lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])))) ||
          lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"]))).includes(window.location.hostname)) && (
          <GoogleAd {...useGoogleAd("300x250", 1)} />
        )}
        <div className="flex flex-col justify-start gap-y-10 p-[0_16px] box-border">
          {!!dayItem?.warnings?.length &&
            dayItem.warnings.map((item: any, index: number) => {
              const warning = appThemeStyle?.[weatherStatus]?.warning?.[item?.Color?.Name?.toLocaleLowerCase()] ?? {};
              return (
                <div key={index} style={{ borderRadius: pxChangeVw("10px") }}>
                  <EarlyWarning
                    title={item.Description?.Localized}
                    content={item?.detail?.start + "-" + item?.detail?.end}
                    onClick={() => {}}
                    color={warning?.fontColor}
                    bgColor={tipsStyle?.background}
                    fillColor={warning?.fillColor}
                  />
                </div>
              );
            })}
          <WeatherMainContent className="content flex flex-col justify-start gap-y-10">
            <div>{$t("title10")}</div>
            <div
              className="flex items-stretch"
              style={{
                paddingBottom: pxChangeVw((countLines(dayItem?.["Day"]?.WeatherText) - 1) * 20 + "px"),
              }}
            >
              <div className="flex-[1] w-75 h-45 flex flex-col items-center translate-y-[-4px]">
                <WeatherImage className="w-56" src={dayItem?.["Day"]?.WeatherIconImg} />
                <p>{dayItem?.["Day"]?.WeatherText}</p>
              </div>
              <div className="flex-[1] text-66 center">
                <span>{dayItem?.Temperature?.Maximum?.Value}</span>
                <div className="flex flex-col justify-between items-center">
                  <span className="text-30">{dayItem?.Temperature?.Maximum?.Unit}</span>
                  <span className="text-10">{$t("title42")}</span>
                </div>
              </div>
            </div>
            <div
              className="rounded-8 font-300 text-10 color-[rgba(255,255,255,0.7)] lh-13 p-8 box-border bg-[rgba(90,90,90,0.3)]"
              style={tipsStyle}
            >
              {dayItem?.["Day"]?.LongPhrase}
            </div>
            {!!dayItem?.["Day"]?.Items?.length && (
              <LayoutGrid
                list={dayItem?.["Day"]?.Items}
                style={{ background: "transparent", backdropFilter: "none", boxShadow: "none" }}
              />
            )}
          </WeatherMainContent>
          {(isTestLink([...domainMap["wi"], ...domainMap["wg"]]) ||
            [...domainMap["wi"], ...domainMap["wg"]].includes(window.location.hostname)) && (
            <GoogleAd {...useGoogleAd("320x100", 5)} />
          )}
          {(isTestLink(lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])))) ||
            lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"]))).includes(window.location.hostname)) && (
            <GoogleAd {...useGoogleAd("300x250", 2)} />
          )}
          <WeatherMainContent className="content flex flex-col justify-start gap-y-10">
            <div className="day">{$t("title11")}</div>
            <div
              className="flex items-stretch"
              style={{
                paddingBottom: pxChangeVw((countLines(dayItem?.["Night"]?.WeatherText) - 1) * 20 + "px"),
              }}
            >
              <div className="flex-[1] w-75 h-45 flex flex-col items-center translate-y-[-4px]">
                <WeatherImage className="w-56" src={dayItem?.["Night"]?.WeatherIconImg} />
                <p>{dayItem?.["Night"]?.WeatherText}</p>
              </div>
              <div className="flex-[1] text-66 center">
                <span>{dayItem?.Temperature?.Minimum?.Value}</span>
                <div className="flex flex-col justify-between items-center">
                  <span className="text-30">{dayItem?.Temperature?.Minimum?.Unit}</span>
                  <span className="text-10">{$t("title43")}</span>
                </div>
              </div>
            </div>
            <div
              className="rounded-8 font-300 text-10 color-[rgba(255,255,255,0.7)] lh-13 p-8 box-border bg-[rgba(90,90,90,0.3)]"
              style={tipsStyle}
            >
              {dayItem?.["Night"]?.LongPhrase}
            </div>
            {!!dayItem?.["Night"]?.Items?.length && (
              <LayoutGrid
                list={dayItem.Night.Items}
                style={{ background: "transparent", backdropFilter: "none", boxShadow: "none" }}
              />
            )}
          </WeatherMainContent>
          {(isTestLink([...domainMap["wi"], ...domainMap["wg"]]) ||
            [...domainMap["wi"], ...domainMap["wg"]].includes(window.location.hostname)) && (
            <GoogleAd {...useGoogleAd("320x100", 6)} />
          )}
          {(isTestLink(lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])))) ||
            lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"]))).includes(window.location.hostname)) && (
            <GoogleAd {...useGoogleAd("300x250", 3)} />
          )}
          {!!dayItem?.Items?.length && <LayoutGrid list={dayItem.Items} />}
          {!isEmptyType(dayItem?.aqi) && <ChartData aqi={dayItem.aqi} />}
          {(dayItem.Sun || dayItem.Moon) && (
            <Sunrise
              forecast1day={{
                Sun: {
                  rate: dayItem.Sun.rate,
                  Rise: dayItem.Sun.Rise,
                  Set: dayItem.Sun.Set,
                },
                Moon: {
                  rate: dayItem.Moon.rate,
                  Rise: dayItem.Moon.Rise,
                  Set: dayItem.Moon.Set,
                  NextDay: dayItem.Moon.NextDay,
                },
              }}
              current={{
                IsDayTime: dayItem.isDayTime,
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default DailyDetail;
